export default class AuthSvc {

  SMALL_MOBILE_LIMIT = 420;
  MOBILE_LIMIT = 600;
  axios = null;
  smallMobile = false;
  mobile = false;
  desktop = false;
  size = window.innerWidth;
  year = 2026;
  app = null;

  constructor(axios) {
    this.axios = axios;
    this.smallMobile = window.innerWidth <= this.SMALL_MOBILE_LIMIT;
    this.mobile = window.innerWidth <= this.MOBILE_LIMIT;
    this.desktop = window.innerWidth > this.MOBILE_LIMIT;

    window.addEventListener('resize', this.updateSize);
  }

  setApp = function (inApp) {
    this.app = inApp;
  }

  showHole = function () {
    var status = window.sessionStorage.getItem('showHole');
    if (status === null) {
      return false;
    }
    return status === 'true';
  }

  setShowHole = function (status) {
    window.sessionStorage.setItem('showHole', status);
  }

  getYear = function() {
    return this.year;
  }

  updateSize = function() {
    this.size = window.innerWidth;
    if (this.size <= this.SMALL_MOBILE_LIMIT) {
      this.smallMobile = true;
      this.mobile = false;
      this.desktop = false;
    }
    else if (this.size <= this.MOBILE_LIMIT) {
      this.smallMobile = true;
      this.mobile = true;
      this.desktop = false;
    }
    else {
      this.smallMobile = false;
      this.mobile = false;
      this.desktop = true;
    }
  }

  clearSession = function() {
    window.sessionStorage.clear();
  }

  getUserInfo = function() {
    const info = window.sessionStorage.getItem('userInfo');
    if (info !== null) {
      return JSON.parse(info);
    }

    return null;
  }

  isFw = function() {
    return false;
  }

  isAdmin = function() {
    const info = window.sessionStorage.getItem('userInfo');
    if (info !== null) {
      var user = JSON.parse(info);
      return user.role === 'ADMIN';
    }

    return false;
  }

  getUserid = function() {
    return window.localStorage.getItem('__dfwvga_userid__');
  }

  getNickName = function() {
    return this.getUserInfo().nickName;
  }

  getFullName = function() {
      const info = window.sessionStorage.getItem('userInfo');
      if (info !== null) {
        const userInfo = JSON.parse(info);
        return userInfo.firstName + ' ' +
        this.firstChar(userInfo.middleName) + ' ' +
        userInfo.lastName;
      }

      return '';
  }

  getFirstName = function() {
      const info = window.sessionStorage.getItem('userInfo');
      if (info !== null) {
        const userInfo = JSON.parse(info);
        return userInfo.firstName;
      }

      return '';
  }

  firstChar = function(str) {
    if (str !== null && str !== '') {
        return str.charAt(0)
    }

    return '';
  }

  setUserid = function(userid) {
    window.localStorage.setItem('__dfwvga_userid__', userid);
  }

  byUser = function() {
    return '?userid=' + this.getUserInfo().playerId;
  }

  isAllowUrl = function() {
    var loc = window.location.href;
    if ((loc.includes("/registration") ||
         loc.includes("/scoring") ||
         loc.includes("/players") ||
         loc.includes("/results") ||
         loc.includes("/cup-leader") ||
         loc.includes("-admin")))
    {
        window.localStorage.setItem('__LastUrl__', loc);
        if (! this.isLogin()) {
          window.location.href = '/signin';
        }
    }
  }

  authenticated = function(successFunction) {
    var _this = this;
    var userid = _this.getUserid();

    if (userid !== null) {
      this.axios.get('/api/authenticate/'+userid+'?tm='+Date.now())
      .then(function (response) {
        let info = response.data;
        if (info.loggedIn === undefined) {
          info.loggedIn = false;
          _this.isAllowUrl();
        } else {
          info.loggedIn = true;
          window.sessionStorage.setItem('userInfo', JSON.stringify(info));
          if (successFunction) {
            successFunction(info);
          }
        }
      })
      .catch(function (error) {
        _this.setLogin(false);
        _this.isAllowUrl();
      });
    }
  }

  login = function(username, password, handleSuccess) {
    var _this = this;

    _this.clearSession();
    _this.setUserid(username);

    _this.axios.post('/login?username='+username+'&password='+password+'&t='+Date.now())
    .then((response) => {
      _this.setUserid(username);
      _this.authenticated(handleSuccess);
    }).catch( error => {
      _this.clearSession();
      window.location.href = '/signin?error=true';
    });
  }

  logout = function() {
    var _this = this;

    this.axios.post('/logout')
    .then(() => {
      _this.clearSession();
      window.localStorage.setItem('__LastUrl__', '/home');
      window.location.href = '/signin';
    }).catch( error => {
      console.log(error);
    });
  }

  setLogin = function(status) {
    var info = this.getUserInfo();
    if (info != null) {
      info.loggedIn = status;
      window.sessionStorage.setItem('userInfo', JSON.stringify(info));
    }
  }

  isLogin = function() {
    var info = this.getUserInfo();
    if (info === null) {
      return false;
    }
    else {
      return info.loggedIn;
    }
  }

  isMember = function() {
    return this.getUserInfo() !== null &&
           this.getUserInfo().status !== null &&
           this.getUserInfo().status === 'MEMBER';
  }

  isJunior = function() {
    return this.getUserInfo() !== null &&
           this.getUserInfo().isJunior !== null &&
           this.getUserInfo().isJunior === 'Y';
  }

  isSenior = function() {
    return  this.getUserInfo() !== null &&
            this.getUserInfo().isJunior !== null &&
            this.getUserInfo().isSenior === 'Y';
  }

  isSmallMobile = function() {
    return this.smallMobile;
  }

  isMobile = function() {
    return this.mobile;
  }

  isDesktop = function() {
    return this.desktop;
  }

  getLastUrl = function() {
    var url = window.localStorage.getItem('__LastUrl__');
    if (url === null || url === '') {
      return '/home';
    }
    else {
      return url;
    }
  }

  getSize = function() {
    return this.size;
  }

  printFormat(format) {
    switch(format) {
      case 'FUN': return "Fun";
      case 'FUN_FW': return "Fun";
      case 'FUN_FW': return "Firewheel";
      case 'FUN_FW_TEAM': return "Firewheel Team";
      case 'MATCH_PLAY': return "Match Play";
      case 'TOURNAMENT': return "Tournament";
      case '2-SCRAMBLE': return "2 Man Scramble";
      default: return 'Unknown';
    }
  }

  putFlyerUrl = function() {
    return "/admin/images/upload/common/flyer.png";
  }

  getFlyerUrl = function() {
    return "/public/images/fetch/common/flyer.png" + "?" + new Date().getTime();
  }

  getBanquetFlyerUrl = function() {
    return "/public/images/fetch/common/banquet-flyer.png" + "?" + new Date().getTime();
  }

  flight = function(flt) {
    if (flt==='Nicklaus') {
      return "NICK";
    } else if (flt==='Palmer') {
      return "PALM";
    }  else {
      return "HOGN";
    }
  }

  fltI = function(flt) {
    if (!this.mobile) {
      return flt;
    }
    if (flt !== '') {
      return flt.charAt(0);
    } else {
      return flt;
    }
  }

  locI = function(loc) {
    if (!this.mobile) {
      return loc;
    }
    if (loc === 'EAST') {
      return 'E';
    } else if (loc === 'WEST') {
      return 'W';
    } else {
      return '';
    }
  }

  getHcp = function(hcp) {
     if (hcp < 60) {
       return Number(hcp).toFixed(1);
     }
     else {
       return "N/A";
     }
  }
}